import React, { useState, useEffect } from "react";
import { Document, Packer, Paragraph,  HeightRule, TextRun, Header, HorizontalPositionRelativeFrom, HorizontalPositionAlign, PageNumber,SimpleField,NumberFormat, VerticalPositionAlign, VerticalPositionRelativeFrom, TextWrappingType, Table,Footer, TableRow, TableCell, AlignmentType, WidthType, BorderStyle, ImageRun, VerticalAlign } from "docx";
import { saveAs } from "file-saver";
import "./BusBar.css";
import { API_URL } from "./API";

const phases = ["R - E", "Y - E", "B - E"];
const phases1 = ["R - Y", "Y - B", "B - R"];
const hipotPhases = ["R-Phase", "Y-Phase", "B-Phase"];
const contactResistancePhases = ["R-Phase", "Y-Phase", "B-Phase"];
const voltageOptions = ["250V", "500V", "1000V", "2500V", "5000V"];
const unitOptions = ["Ω", "KΩ", "MΩ", "TΩ", "GΩ"];

const BusbarTestReport = ({clearAllFormData, formData, project,goBack}) => {
  const [isLoading, setIsLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [formSubmitted, setFormSubmitted] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");
 
  const [validationErrors, setValidationErrors] = useState({
    description: "",
    customer: "",
    client: ""
  });

  const [projectDetails, setProjectDetails] = useState({
    subProjectName: "",
    categoryName: "",
    subcategoryName: "",
    equipmentName: "",
    projectId: "",
    location: ""
  });

 
  const fetchClientName = async (clientId) => {
    try {
      const response = await fetch(`${API_URL}/clients/get_client`, {
        method: 'GET',
        headers: { 'Content-Type': 'application/json' },
        mode: 'cors',
      });
      
      if (response.ok) {
        const result = await response.json();
        let clientsData = Array.isArray(result) ? result : result.data || result.clients || [];
        const client = clientsData.find(c => c.client_id === clientId || c.id === clientId);
        return client ? client.client_name : "Unknown Client";
      }
    } catch (error) {
     
    }
    return "Unknown Client";
  };

  const [form, setForm] = useState({
    description: "",
    date: "",
    customer: "",
    project: "",
    reportNo: "",
    location: "",
    client: ""
  });

 
  useEffect(() => {
    const loadProjectData = async () => {
      if (project) {
        let clientName = project?.clientName || project?.client_name;
        
        if (!clientName && project?.client) {
          clientName = await fetchClientName(project.client);
        }
        
        setForm(prev => ({
          ...prev,
          project: project?.name || '',
          client: clientName || '',
          
        }));

        
        setProjectDetails(prev => ({
          ...prev,
          projectId: project?.id || project?.project_id || '',
          
        }));
      }
    };
    
    loadProjectData();
  }, [project]);

  const getNewPhaseValues = () =>
    phases.map(() => ({ voltage: "", measuredValue: "", measuredUnit: "" }));

  const getNewPhase1Values = () =>
    phases1.map(() => ({ voltage: "", measuredValue: "", measuredUnit: "" }));

  const getNewHipotValues = () =>
    hipotPhases.map(() => ({ voltage: "", leakage: "" }));

  const getNewContactResistanceValues = () =>
    contactResistancePhases.map(() => ({ 
      joint1: "", 
      joint2: "", 
      overall: "" 
    }));

  const defaultTestData = {
    beforeRun1: getNewPhaseValues(),
    afterRun1: getNewPhaseValues(),
    beforeRun2: getNewPhase1Values(),
    afterRun2: getNewPhase1Values(),
    hipotRun: getNewHipotValues(),
    contactResistance: getNewContactResistanceValues(),
  };
  
  const [testData, setTestData] = useState(defaultTestData);

  const clearAllStorageData = () => {
    localStorage.removeItem('busbarFormData');
    localStorage.removeItem('busbarTestData');
    localStorage.removeItem('contactResistanceData');
    
    setForm({
      description: "",
      date: "",
      customer: "",
      project: "",
      reportNo: "",
      location: "",
      client: ""
    });

    setTestData(defaultTestData);

    setValidationErrors({
      description: "",
      customer: "",
      client: ""
    });
    setProjectDetails({
      subProjectName: "",
      categoryName: "",
      subcategoryName: "",
      equipmentName: "",
      projectId: "",
      location: ""
    });
    setFormSubmitted(false);
    setSuccessMessage("");
    setErrorMessage("");
  };

  const loadAllFormDataFromStorage = () => {
    try {
      const allFormData = {
        form: {},
        testData: {}
      };

      const busbarFormData = localStorage.getItem('busbarFormData');
      if (busbarFormData) {
        const parsedbusbarFormData = JSON.parse(busbarFormData);
        allFormData.form = parsedbusbarFormData;
      }

      const busbarTestData = localStorage.getItem('busbarTestData');
      if (busbarTestData) {
        const parsedTestData = JSON.parse(busbarTestData);
        allFormData.testData = parsedTestData;
      }

      return allFormData;
    } catch (error) {
      
      return {
        form: {},
        testData: {}
      };
    }
  };

  const resetAllFormStates = () => {
    setProjectDetails({
      subProjectName: "",
      categoryName: "",
      subcategoryName: "",
      equipmentName: "",
      projectId: "",
      location: ""
    });

    setFormSubmitted(false);
    setErrorMessage("");
    setSuccessMessage("");
    
    if (clearAllFormData && typeof clearAllFormData === 'function') {
      clearAllFormData();
    }
  };

  useEffect(() => {
    try {
      const localNavbarData = localStorage.getItem('navbarData');
      const localProjectData = localStorage.getItem('createReportData');
     
      if (localNavbarData) {
        const parsedNavbarData = JSON.parse(localNavbarData);
        if (parsedNavbarData.location) {
          setProjectDetails(prev => ({
            ...prev,
            location: parsedNavbarData.location
          }));
         
          setForm(prev => ({
            ...prev,
            location: parsedNavbarData.location
          }));
        }
      }
   
      if (localProjectData) {
        const parsedProjectData = JSON.parse(localProjectData);
        const projectDetails = {
          subProjectName: parsedProjectData.sub_project_name || "",
          categoryName: parsedProjectData.category_name || "",
          subcategoryName: parsedProjectData.subcategory_name || "",
          equipmentName: parsedProjectData.equipment_name || "",
          projectId: parsedProjectData.project_id || "",
          location: parsedProjectData.location || (localNavbarData ? JSON.parse(localNavbarData).location || "" : "")
        };
       
        setProjectDetails(projectDetails);
       
        setForm(prev => ({
          ...prev,
          project: projectDetails.subProjectName || prev.project,
          
        }));
      }
     
      const savedFormData = localStorage.getItem('busbarFormData');
      if (savedFormData) {
        const parsedFormData = JSON.parse(savedFormData);
        setForm(parsedFormData);
      }
     
      const savedTestData = localStorage.getItem('busbarTestData');
      if (savedTestData) {
        try {
          const parsedTestData = JSON.parse(savedTestData);
          
          const isValidTestData = Object.keys(defaultTestData).every(key => {
            if (key === 'contactResistance') {
              return Array.isArray(parsedTestData[key]) && parsedTestData[key].length === contactResistancePhases.length;
            }
            if (key === 'hipotRun') {
              return Array.isArray(parsedTestData[key]) && parsedTestData[key].length === hipotPhases.length;
            }
            if (key.includes('Run2')) {
              return Array.isArray(parsedTestData[key]) && parsedTestData[key].length === phases1.length;
            }
            return Array.isArray(parsedTestData[key]) && parsedTestData[key].length === phases.length;
          });
          
          if (isValidTestData) {
            setTestData(parsedTestData);
          } else {
           
            setTestData(defaultTestData);
          }
        } catch (parseError) {
          
          setTestData(defaultTestData);
        }
      }
    } catch (error) {
     
      setErrorMessage("Failed to load saved data");
    }
  }, []);

  const validateDescriptionInput = (value) => {
    const descriptionRegex = /^[A-Za-z\s/ ]*$/;
    return descriptionRegex.test(value);
  };

  const validateReportLocationInput = (value) => {
    const reportLocationRegex = /^[A-Za-z0-9\-,s ]*$/;
    return reportLocationRegex.test(value);
  };

  const validateClientCustomerInput = (value) => {
    const clientCustomerRegex = /^[A-Za-z\s ]*$/;
    return clientCustomerRegex.test(value);
  };

  const validateProjectInput = (value) => {
    const projectRegex = /^[A-Za-z0-9\-,s ]*$/;
    return projectRegex.test(value);
  };

  const validateMeasuredValueInput = (value) => {
    const measuredValueRegex = /^[0-9.<> ]*$/;
    return measuredValueRegex.test(value) && value.length <= 10;
  };

  const validateAppliedVoltageInput = (value) => {
    const voltageRegex = /^[A-Za-z0-9 ]*$/;
    return voltageRegex.test(value);
  };

  const validateLeakageCurrentInput = (value) => {
    const numericRegex = /^[0-9. ]*$/;
    return numericRegex.test(value);
  };

  const validateContactResistanceInput = (value) => {
    const contactResistanceRegex = /^[0-9. ]*$/;
    return contactResistanceRegex.test(value) && value.length <= 15;
  };

  const handleFormChange = (key, value) => {
    if (key === 'description') {
      if (!validateDescriptionInput(value)) {
        setValidationErrors(prev => ({
          ...prev,
          [key]: "Only alphabetic characters and '/' are allowed"
        }));
        return;
      }
    } else if (['reportNo', 'location'].includes(key)) {
      if (!validateReportLocationInput(value)) {
        setValidationErrors(prev => ({
          ...prev,
          [key]: "Only alphanumeric characters and '-' are allowed"
        }));
        return;
      }
    } else if (['client', 'customer'].includes(key)) {
      if (!validateClientCustomerInput(value)) {
        setValidationErrors(prev => ({
          ...prev,
          [key]: "Only alphabetic characters are allowed"
        }));
        return;
      }
    } else if (key === 'project') {
      if (!validateProjectInput(value)) {
        setValidationErrors(prev => ({
          ...prev,
          [key]: "Only alphanumeric characters are allowed"
        }));
        return;
      }
    }
    
    setValidationErrors(prev => ({
      ...prev,
      [key]: ""
    }));
    
    setForm(prev => {
      const updated = { ...prev, [key]: value };
      localStorage.setItem('busbarFormData', JSON.stringify(updated));
      return updated;
    });
  };

  const handleTestChange = (section, index, field, value) => {
    if (field === 'measuredValue') {
      if (!validateMeasuredValueInput(value)) {
        return;
      }
    }
    
    if (field === 'voltage' && section.includes('hipot')) {
      if (!validateAppliedVoltageInput(value)) {
        return; 
      }
    }
    
    if (field === 'leakage') {
      if (!validateLeakageCurrentInput(value)) {
        return; 
      }
    }
    
    setTestData(prev => {
      const updated = { ...prev };
      
      if (!updated[section]) {
        if (section === 'contactResistance') {
          updated[section] = getNewContactResistanceValues();
        } else if (section === 'hipotRun') {
          updated[section] = getNewHipotValues();
        } else if (section.includes('Run2')) {
          updated[section] = getNewPhase1Values();
        } else {
          updated[section] = getNewPhaseValues();
        }
      }
      
      if (!Array.isArray(updated[section]) || updated[section].length === 0) {
        if (section === 'contactResistance') {
          updated[section] = getNewContactResistanceValues();
        } else if (section === 'hipotRun') {
          updated[section] = getNewHipotValues();
        } else if (section.includes('Run2')) {
          updated[section] = getNewPhase1Values();
        } else {
          updated[section] = getNewPhaseValues();
        }
      }
      
      updated[section] = [...updated[section]];
      
      if (!updated[section][index]) {
        if (section === 'contactResistance') {
          updated[section][index] = { joint1: "", joint2: "", overall: "" };
        } else if (section === 'hipotRun') {
          updated[section][index] = { voltage: "", leakage: "" };
        } else {
          updated[section][index] = { voltage: "", measuredValue: "", measuredUnit: "" };
        }
      }
      
      updated[section][index] = { ...updated[section][index], [field]: value };
      localStorage.setItem('busbarTestData', JSON.stringify(updated));
      return updated;
    });
  };

  const handleContactResistanceChange = (index, field, value) => {
    if (!validateContactResistanceInput(value)) {
      return;
    }
    
    handleTestChange('contactResistance', index, field, value);
  };

 const redirectToHome = () => {
  if (window.confirm("Are you sure you want to leave this page")) {  
    localStorage.setItem('openReportsOnLoad', 'true');
    window.location.href = "/";
  }
};

  const handleCancel = () => {
   window.location.reload();
  };

  const validateTextFields = () => {
    const validationMap = {
      'description': validateDescriptionInput,
      'customer': validateClientCustomerInput,
      'client': validateClientCustomerInput,
      'reportNo': validateReportLocationInput,
      'location': validateReportLocationInput,
      'project': validateProjectInput
    };
    
    let isValid = true;
    const newValidationErrors = { ...validationErrors };
    
    Object.entries(validationMap).forEach(([field, validationFn]) => {
      if (form[field]) {
        if (!validationFn(form[field])) {
          if (field === 'description') {
            newValidationErrors[field] = "Only alphabetic characters and '/' are allowed";
          } else if (['reportNo', 'location'].includes(field)) {
            newValidationErrors[field] = "Only alphanumeric characters and '-' are allowed";
          } else if (['client', 'customer'].includes(field)) {
            newValidationErrors[field] = "Only alphabetic characters are allowed";
          } else if (field === 'project') {
            newValidationErrors[field] = "Only alphanumeric characters are allowed";
          }
          isValid = false;
        } else {
          newValidationErrors[field] = "";
        }
      }
    });
    
    setValidationErrors(newValidationErrors);
    return isValid;
  };
  
  const validateForm = () => {
    if (!form.date || !form.project || !form.reportNo) {
      setErrorMessage("Please fill in all required fields in the form section.");
      return false;
    }
    
    return validateTextFields();
  };





const generateWordBlob = () => {
  return new Promise((resolve, reject) => {
    try {
      
      const storedFormData = JSON.parse(localStorage.getItem('busbarFormData') || '{}');
      const busbarTestData = JSON.parse(localStorage.getItem('busbarTestData') || '{}');

      
      const tableBorders = {
        top: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
        bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
        left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
        right: { style: BorderStyle.SINGLE, size: 1, color: "000000" }
      };

      function findValue(data, searchTerms, defaultValue = "N/A") {
        if (!data || typeof data !== 'object') return defaultValue;
        
        const terms = Array.isArray(searchTerms) ? searchTerms : [searchTerms];
        
        for (let term of terms) {
          if (data[term] !== undefined && data[term] !== null && data[term] !== '') {
            return data[term];
          }
        }
        
        const dataKeys = Object.keys(data);
        for (let term of terms) {
          const termLower = term.toLowerCase();
          for (let key of dataKeys) {
            if (key.toLowerCase() === termLower && data[key] !== undefined && data[key] !== null && data[key] !== '') {
              return data[key];
            }
          }
        }
        
        for (let term of terms) {
          const termLower = term.toLowerCase();
          for (let key of dataKeys) {
            if (key.toLowerCase().includes(termLower) && data[key] !== undefined && data[key] !== null && data[key] !== '') {
              return data[key];
            }
          }
        }
        
        return defaultValue;
      }

      function safeToString(value) {
        if (value === null || value === undefined || value === '' || value === 'N/A') {
          return "";
        }
        return value.toString();
      }

      
      const fetchImageAsBase64 = (url) => {
        return new Promise((resolve, reject) => {
          const img = new Image();
          img.crossOrigin = 'anonymous';
          img.onload = function() {
            try {
              const canvas = document.createElement('canvas');
              const ctx = canvas.getContext('2d');
              canvas.width = img.width;
              canvas.height = img.height;
              ctx.drawImage(img, 0, 0);
              const dataURL = canvas.toDataURL('image/png');
              const base64 = dataURL.split(',')[1];
              resolve(base64);
            } catch (error) {
             
              resolve(null);
            }
          };
          img.onerror = function() {
           
            resolve(null);
          };
          img.src = url;
        });
      };

      
      const createLightWatermark = (base64Data) => {
        return new Promise((resolve) => {
          if (!base64Data) {
            resolve(null);
            return;
          }
          
          try {
            const img = new Image();
            img.onload = function() {
              const canvas = document.createElement('canvas');
              const ctx = canvas.getContext('2d');
              canvas.width = img.width;
              canvas.height = img.height;
              
              ctx.globalAlpha = 0.15; 
              ctx.drawImage(img, 0, 0);
              
              const lightDataURL = canvas.toDataURL('image/png');
              const lightBase64 = lightDataURL.split(',')[1];
              resolve(lightBase64);
            };
            img.onerror = function() {
              resolve(null);
            };
            img.src = 'data:image/png;base64,' + base64Data;
          } catch (error) {
           
            resolve(null);
          }
        });
      };

      
      const documentSections = [];

      
      const logoUrl = "https://i.ibb.co/BHKCMXV8/Whats-App-Image-2025-06-16-at-11-21-26-AM.jpg";
      const watermarkUrl = "https://i.ibb.co/BHKCMXV8/Whats-App-Image-2025-06-16-at-11-21-26-AM.jpg"; 

      
      Promise.all([
        fetchImageAsBase64(logoUrl),
        fetchImageAsBase64(watermarkUrl)
      ]).then(([logoBase64, watermarkBase64]) => {
        
        
        createLightWatermark(watermarkBase64).then((lightWatermarkBase64) => {
       
        
       
         const headerElements = [];

        if (logoBase64) {
          headerElements.push(
            new Table({
              width: { size: 100, type: WidthType.PERCENTAGE },
              rows: [
                new TableRow({
                  children: [
                    new TableCell({
                      children: [
                        new Paragraph({
                          children: [
                            new ImageRun({
                              data: logoBase64,
                              transformation: {
                                width: 80,
                                height: 80
                              }
                            })
                          ],
                          alignment: AlignmentType.CENTER,
                        })
                      ],
                      verticalAlign: VerticalAlign.CENTER,
                      borders: {
                        top: { style: BorderStyle.SINGLE, size: 1 },
                        bottom: { style: BorderStyle.SINGLE, size: 1 },
                        left: { style: BorderStyle.SINGLE, size: 1 },
                        right: { style: BorderStyle.SINGLE, size: 1 }
                      },
                      width: { size: 20, type: WidthType.PERCENTAGE },
                      margins: {
                        top: 0,
                        bottom: 0,
                        left: 0,
                        right: 0
                      }
                    }),
                    new TableCell({
                      children: [
                        new Paragraph({
                          children: [
                            new TextRun({
                              text: "PIE POWER PRIVATE LIMITED",
                              font: "Times New Roman",
                              color:"#1e402c",
                              bold: true,
                              size: 36
                            })
                          ],
                          alignment: AlignmentType.CENTER
                        }),
                        new Paragraph({
                          children: [
                            new TextRun({
                              text: "VISAKHAPATNAM, ANDHRA PRADESH INDIA-531163",
                              font: "helvetica",
                              size: 20
                            })
                          ],
                          alignment: AlignmentType.CENTER
                        }),
                        new Paragraph({
                          children: [
                            new TextRun({
                              text: "Email: info@piepower.in, Web: piepower.in, Contact: +91 8186084709",
                              font: "helvetica",
                              size: 20
                            })
                          ],
                          alignment: AlignmentType.CENTER
                        })
                      ],
                      borders: {
                        top: { style: BorderStyle.SINGLE, size: 1 },
                        bottom: { style: BorderStyle.SINGLE, size: 1 },
                        left: { style: BorderStyle.SINGLE, size: 1 },
                        right: { style: BorderStyle.SINGLE, size: 1 }
                      },
                      width: { size: 80, type: WidthType.PERCENTAGE }
                    })
                  ]
                })
              ]
            })
          );
        } else {
          
          headerElements.push(
            new Paragraph({
              children: [
                new TextRun({
                  text: "PIE POWER PRIVATE LIMITED",
                  font: "Times New Roman",
                  color:"#1e402c",
                  bold: true,
                  size: 36
                })
              ],
              alignment: AlignmentType.CENTER
            }),
            new Paragraph({
              children: [
                new TextRun({
                  text: "VISAKHAPATNAM, ANDHRA PRADESH INDIA-531163",
                  font: "helvetica",
                  size: 20
                })
              ],
              alignment: AlignmentType.CENTER
            }),
            new Paragraph({
              children: [
                new TextRun({
                  text: "Email: info@piepower.in, Web: piepower.in, Contact: +91 8186084709",
                  font: "helvetica",
                  size: 20
                })
              ],
              alignment: AlignmentType.CENTER
            })
          );
        }

        headerElements.push(new Paragraph({ text: "" })); 
        documentSections.push(...headerElements);

        
        documentSections.push(
          new Table({
            width: { size: 100, type: WidthType.PERCENTAGE },
            rows: [
              new TableRow({
                children: [
                  new TableCell({
                    children: [new Paragraph({ alignment: AlignmentType.CENTER,children: [new TextRun({ text:   "Description", font: "Courier New", bold: true })] })],
                    borders: tableBorders,
                    width: { size: 20, type: WidthType.PERCENTAGE }
                  }),
                  new TableCell({
                    children: [new Paragraph({ alignment: AlignmentType.CENTER,children: [new TextRun({ text: "BUSBAR INSPECTION / TEST REPORT", font: "Courier New", bold:true })] })],
                    borders: tableBorders,
                    width: { size: 50, type: WidthType.PERCENTAGE }
                  }),
                  new TableCell({
                    children: [new Paragraph({ alignment: AlignmentType.CENTER,children: [new TextRun({ text:   "Date", font: "Courier New",bold: true })] })],
                    borders: tableBorders,
                    width: { size: 15, type: WidthType.PERCENTAGE }
                  }),
                  new TableCell({
                    children: [new Paragraph({ alignment: AlignmentType.CENTER,children: [new TextRun({ text:   safeToString(storedFormData?.date), font: "Courier New" })] })],
                    borders: tableBorders,
                    width: { size: 15, type: WidthType.PERCENTAGE }
                  })
                ]
              }),
              new TableRow({
                children: [
                  new TableCell({
                    children: [new Paragraph({ alignment: AlignmentType.CENTER,children: [new TextRun({ text:   "Project", font: "Courier New", bold: true })] })],
                    borders: tableBorders
                  }),
                  new TableCell({
                    children: [new Paragraph({ alignment: AlignmentType.CENTER,children: [new TextRun({ text:   safeToString(storedFormData?.project), font: "Courier New", bold: true })] })],
                    borders: tableBorders
                  }),
                  new TableCell({
                    children: [new Paragraph({ alignment: AlignmentType.CENTER,children: [new TextRun({ text:   "Report No", font: "Courier New",bold: true })] })],
                    borders: tableBorders
                  }),
                  new TableCell({
                    children: [new Paragraph({ alignment: AlignmentType.CENTER,children: [new TextRun({ text:   safeToString(storedFormData?.reportNo), font: "Courier New" })] })],
                    borders: tableBorders
                  })
                ]
              }),
              new TableRow({
                children: [
                  new TableCell({
                    children: [new Paragraph({ alignment: AlignmentType.CENTER,children: [new TextRun({ text:   "Customer", font: "Courier New", bold: true })] })],
                    borders: tableBorders
                  }),
                  new TableCell({
                    children: [new Paragraph({ alignment: AlignmentType.CENTER,children: [new TextRun({ text:   safeToString(storedFormData?.customer), font: "Courier New", bold: true })] })],
                    borders: tableBorders
                  }),
                  new TableCell({
                    children: [new Paragraph({ children: [new TextRun({ text:   "", font: "Courier New" })] })],
                    borders: tableBorders
                  }),
                  new TableCell({
                    children: [new Paragraph({ children: [new TextRun({ text:   "", font: "Courier New" })] })],
                    borders: tableBorders
                  })
                ]
              }),
              new TableRow({
                children: [
                  new TableCell({
                    children: [new Paragraph({ alignment: AlignmentType.CENTER,children: [new TextRun({ text:   "Client", font: "Courier New", bold: true })] })],
                    borders: tableBorders
                  }),
                  new TableCell({
                    children: [new Paragraph({ alignment: AlignmentType.CENTER,children: [new TextRun({ text:   safeToString(storedFormData?.client), font: "Courier New", bold: true })] })],
                    borders: tableBorders,
                    
                  }),
                  new TableCell({
                    children: [new Paragraph({ children: [new TextRun({ text:   "", font: "Courier New" })] })],
                    borders: tableBorders
                  }),
                  new TableCell({
                    children: [new Paragraph({ children: [new TextRun({ text:   "", font: "Courier New" })] })],
                    borders: tableBorders
                  })
                ]
              })
            ]
          })
        );

        documentSections.push(new Paragraph({ text: "" })); 


       
             documentSections.push(
                  new Paragraph({
                    children: [
                      new TextRun({
                        text: "LOCATION: ",
                        font: "Courier New",
                        bold: true,
                        size: 24
                      }),
                      new TextRun({
                        text: storedFormData.location || '',
                        font: "Courier New",
                        size: 24
                      })
                    ]
                  })
                );
              
                documentSections.push(new Paragraph({ text: "" }));

        
        documentSections.push(
          new Paragraph({
            children: [
              new TextRun({
                text: "CONTACT RESISTANCE TEST",
                font: "Courier New",
                bold: true,
                size: 24
              })
            ]
          })
        );

        documentSections.push(new Paragraph({ text: "" })); 

        const contactResistancePhases = ["R-Phase", "Y-Phase", "B-Phase"];
        const contactData = busbarTestData.contactResistance || [];

        const contactRows = [
          new TableRow({
            children: [
              new TableCell({
                children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: "S.No", font: "Courier New", bold: true })] })],
                borders: tableBorders,
                shading: { fill: "a6a6a6" },
                width: { size: 15, type: WidthType.PERCENTAGE }
              }),
              new TableCell({
                children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: "Reference", font: "Courier New", bold: true })] })],
                borders: tableBorders,
                shading: { fill: "a6a6a6" },
                width: { size: 15, type: WidthType.PERCENTAGE }
              }),
              new TableCell({
                children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: "Measured Resistance (µΩ)", font: "Courier New", bold: true })] })],
                borders: tableBorders,
                shading: { fill: "a6a6a6" },
                width: { size: 70, type: WidthType.PERCENTAGE },
                columnSpan: 3
              })
            ]
          }),
          new TableRow({
            children: [
              new TableCell({
                children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: "", font: "Courier New", bold: true })] })],
                borders: tableBorders,
                shading: { fill: "a6a6a6" }
              }),
              new TableCell({
                children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: "", font: "Courier New", bold: true })] })],
                borders: tableBorders,
                shading: { fill: "a6a6a6" }
              }),
              new TableCell({
                children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: "JOINT 1", font: "Courier New", bold: true })] })],
                borders: tableBorders,
                shading: { fill: "a6a6a6" },
                width: { size: 23, type: WidthType.PERCENTAGE }
              }),
              new TableCell({
                children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: "JOINT 2", font: "Courier New", bold: true })] })],
                borders: tableBorders,
                shading: { fill: "a6a6a6" },
                width: { size: 23, type: WidthType.PERCENTAGE }
              }),
              new TableCell({
                children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: "OVERALL", font: "Courier New", bold: true })] })],
                borders: tableBorders,
                shading: { fill: "a6a6a6" },
                width: { size: 24, type: WidthType.PERCENTAGE }
              })
            ]
          })
        ];

        contactResistancePhases.forEach((phase, index) => {
          const phaseData = contactData[index] || {};
          contactRows.push(
            new TableRow({
              children: [
                new TableCell({
                  children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: (index + 1).toString(), bold: true, font: "Courier New" })] })],
                  borders: tableBorders,
                  shading: { fill: "a6a6a6" }
                }),
                new TableCell({
                  children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: phase, bold: true, font: "Courier New" })] })],
                  borders: tableBorders,
                  shading: { fill: "a6a6a6" }
                }),
                new TableCell({
                  children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: safeToString(phaseData.joint1), font: "Courier New" })] })],
                  borders: tableBorders
                }),
                new TableCell({
                  children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: safeToString(phaseData.joint2), font: "Courier New" })] })],
                  borders: tableBorders
                }),
                new TableCell({
                  children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: safeToString(phaseData.overall), font: "Courier New" })] })],
                  borders: tableBorders
                })
              ]
            })
          );
        });

        documentSections.push(
          new Table({
            width: { size: 100, type: WidthType.PERCENTAGE },
            rows: contactRows
          })
        );

        documentSections.push(new Paragraph({ text: "" }));

       
        documentSections.push(
          new Paragraph({
            children: [
              new TextRun({
                text: "INSULATION RESISTANCE TEST",
                font: "Courier New",
                bold: true,
                size: 24
              })
            ]
          })
        );

     

        const createInsulationTestTable = (title, data, phases) => {
          const tableRows = [
            new TableRow({
              children: [
                new TableCell({
                  children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: "Phase", font: "Courier New", bold: true })] })],
                  borders: tableBorders,
                  shading: { fill: "a6a6a6" },
                  width: { size: 32, type: WidthType.PERCENTAGE }
                }),
                new TableCell({
                  children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: "Applied Voltage(V)", font: "Courier New", bold: true })] })],
                  borders: tableBorders,
                  shading: { fill: "a6a6a6" },
                  width: { size: 34, type: WidthType.PERCENTAGE }
                }),
                new TableCell({
                  children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: "Measured Value", font: "Courier New", bold: true })] })],
                  borders: tableBorders,
                  shading: { fill: "a6a6a6" },
                  width: { size: 34, type: WidthType.PERCENTAGE }
                })
              ]
            })
          ];

          phases.forEach((phase, index) => {
            const phaseData = data[index] || {};
            tableRows.push(
              new TableRow({
                children: [
                  new TableCell({
                    children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: phase, font: "Courier New", bold:true })] })],
                    borders: tableBorders,
                    shading: { fill: "a6a6a6" },
                  }),
                  new TableCell({
                    children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: safeToString(phaseData.voltage), font: "Courier New" })] })],
                    borders: tableBorders
                  }),
                  new TableCell({
                    children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: `${safeToString(phaseData.measuredValue)} ${safeToString(phaseData.measuredUnit)}`, font: "Courier New" })] })],
                    borders: tableBorders
                  })
                ]
              })
            );
          });

          return [
            new Paragraph({
              children: [
                new TextRun({
                  text: title,
                  font: "Courier New",
                  bold: true,
                  size: 20
                })
              ],
              spacing: { before: 200, after: 100 }
            }),
            new Table({
              width: { size: 100, type: WidthType.PERCENTAGE },
              rows: tableRows
            }),
            new Paragraph({ text: "" })
          ];
        };

       
        const phases1 = ["R - E", "Y - E", "B - E"];
        const phases2 = ["R - Y", "Y - B", "B - R"];

        
        
        const beforeRun1Elements = createInsulationTestTable(
          "BEFORE HIPOT INSULATION RESISTANCE TEST",
          busbarTestData.beforeRun1 || [],
          phases1
        );
        documentSections.push(...beforeRun1Elements);


        const beforeRun2Elements = createInsulationTestTable(
          "BEFORE HIPOT INSULATION RESISTANCE TEST",
          busbarTestData.beforeRun2 || [],
          phases2
        );
        documentSections.push(...beforeRun2Elements);

    
        const afterRun1Elements = createInsulationTestTable(
          "AFTER HIPOT INSULATION RESISTANCE TEST",
          busbarTestData.afterRun1 || [],
          phases1
        );
        documentSections.push(...afterRun1Elements);

       
        
        
        

     
        const afterRun2Elements = createInsulationTestTable(
          "AFTER HIPOT INSULATION RESISTANCE TEST ",
          busbarTestData.afterRun2 || [],
          phases2
        );
        documentSections.push(...afterRun2Elements);

        
        documentSections.push(
          new Paragraph({
            children: [
              new TextRun({
                text: "HIPOT TEST",
                font: "Courier New",
                bold: true,
                size: 24
              })
            ],
            spacing: { before: 100, after: 100 }
          })
        );

          documentSections.push(
          new Paragraph({
            children: [
              new TextRun({
                text: "Test Result :",
                font: "Courier New",
                bold: true,
                size: 24
              })
            ]
          })
        );

        documentSections.push(new Paragraph({ text: "" }));

        const hipotRows = [
          new TableRow({
            children: [
              new TableCell({
                children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: "Phase", font: "Courier New", bold: true })] })],
                borders: tableBorders,
                shading: { fill: "a6a6a6" },
                width: { size: 32, type: WidthType.PERCENTAGE }
              }),
              new TableCell({
                children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: "Applied AC Voltage (KV)", font: "Courier New", bold: true })] })],
                borders: tableBorders,
                shading: { fill: "a6a6a6" },
                width: { size: 34, type: WidthType.PERCENTAGE }
              }),
              new TableCell({
                children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: "Measured Leakage Current (mA)", font: "Courier New", bold: true })] })],
                borders: tableBorders,
                shading: { fill: "a6a6a6" },
                width: { size: 34, type: WidthType.PERCENTAGE }
              })
            ]
          })
        ];

        const hipotPhases = ["R-Phase", "Y-Phase", "B-Phase"];
        const hipotData = busbarTestData.hipotRun || [];

        hipotPhases.forEach((phase, index) => {
          const phaseData = hipotData[index] || {};
          hipotRows.push(
            new TableRow({
              children: [
                new TableCell({
                  children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: phase, font: "Courier New", bold:true })] })],
                  borders: tableBorders,
                  shading: { fill: "a6a6a6" }
                }),
                new TableCell({
                  children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: safeToString(phaseData.voltage), font: "Courier New" })] })],
                  borders: tableBorders
                }),
                new TableCell({
                  children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: safeToString(phaseData.leakage), font: "Courier New" })] })],
                  borders: tableBorders
                })
              ]
            })
          );
        });

        documentSections.push(
          new Table({
            width: { size: 100, type: WidthType.PERCENTAGE },
            rows: hipotRows
          })
        );
        const convertInchesToTwip = (inches) => {
          return Math.round(inches * 1440);
        };
const footerTable = new Table({
  width: { size: 100, type: WidthType.PERCENTAGE, },
  alignment: AlignmentType.LEFT,
  rows: [
    new TableRow({
      height: { value: convertInchesToTwip(0.5), rule: HeightRule.ATLEAST },
      children: [
        new TableCell({
          children: [
            new Paragraph({
              alignment: AlignmentType.LEFT,
              spacing: { before: 0, after: 0 },
              children: [
                new TextRun({
                  text: "Pie Power",
                  font: "Courier New",
                  bold: true,
                  size: 18
                })
              ]
            }),
          ],
          borders: tableBorders,
          width: { size: 25, type: WidthType.PERCENTAGE },
          verticalAlign: VerticalAlign.TOP,
          margins: {
            top: convertInchesToTwip(0.1),
            bottom: convertInchesToTwip(0.25),
            left: convertInchesToTwip(0.25),
            right: convertInchesToTwip(0.25)
          }
        }),
        new TableCell({
          children: [
            new Paragraph({
              alignment: AlignmentType.LEFT,
              spacing: { before: 0, after: 0 },
              children: [
                new TextRun({
                  text: "TPREL",
                  font: "Courier New",
                  bold: true,
                  size: 18
                })
              ]
            }),
          ],
          borders: tableBorders,
          width: { size: 25, type: WidthType.PERCENTAGE },
          verticalAlign: VerticalAlign.TOP,
          margins: {
            top: convertInchesToTwip(0.1),
            bottom: convertInchesToTwip(0.25),
            left: convertInchesToTwip(0.25),
            right: convertInchesToTwip(0.25)
          }
        }),
        new TableCell({
          children: [
            new Paragraph({
              alignment: AlignmentType.LEFT,
              spacing: { before: 0, after: 0 },
              children: [
                new TextRun({
                  text: "TPREL",
                  font: "Courier New",
                  bold: true,
                  size: 18
                })
              ]
            }),
          ],
          borders: tableBorders,
          width: { size: 25, type: WidthType.PERCENTAGE },
          verticalAlign: VerticalAlign.TOP,
          margins: {
            top: convertInchesToTwip(0.1),
            bottom: convertInchesToTwip(0.25),
            left: convertInchesToTwip(0.25),
            right: convertInchesToTwip(0.25)
          }
        }),
        new TableCell({
          children: [
            new Paragraph({
              alignment: AlignmentType.LEFT,
              spacing: { before: 0, after: 0 },
              children: [
                new TextRun({
                  text: "TPREL",
                  font: "Courier New",
                  bold: true,
                  size: 18
                }),
                new SimpleField({
                  instruction: "PAGE",
                  children: [
                    new TextRun({
                      text: "1",
                      font: "Courier New",
                      size: 16
                    })
                  ]
                }),
                new SimpleField({
                  instruction: "NUMPAGES",
                  children: [
                    new TextRun({
                      text: "1",
                      font: "Courier New",
                      size: 16
                    })
                  ]
                })
              ]
            }),
          ],
          borders: tableBorders,
          width: { size: 25, type: WidthType.PERCENTAGE },
          verticalAlign: VerticalAlign.TOP,
          margins: {
            top: convertInchesToTwip(0.1),
            bottom: convertInchesToTwip(0.25),
            left: convertInchesToTwip(0.25),
            right: convertInchesToTwip(0.25)
          }
        })
      ]
    })
  ]
});
        const pageBorders = {
  pageBorderTop: {
    style: BorderStyle.DOUBLE,
    size: 6,
    color: "000000",
    space: 3
  },


  pageBorderRight: {
    style: BorderStyle.DOUBLE,
    size: 6,
    color: "000000",
    space: 3
  },
  pageBorderBottom: {
    style: BorderStyle.DOUBLE,
    size: 6,
    color: "000000",
    space: 3
  },
  pageBorderLeft: {
    style: BorderStyle.DOUBLE,
    size: 6,
    color: "000000",
    space: 3
  }
};

      const doc = new Document({
  sections: [
    {
      properties: {
        page: {
          margin: {
            top: convertInchesToTwip(0.5),
            right: convertInchesToTwip(0.5),
            bottom: convertInchesToTwip(1.0),
            left: convertInchesToTwip(0.5)
          },
          borders: pageBorders,
          pageNumbers: {
            start: 1,
            formatType: NumberFormat.DECIMAL
          }
        }
      },
      footers: {
        default: new Footer({
          children: [
            footerTable,
            new Paragraph({
              children: [
                new TextRun({
                  text: "Page ",
                  font: "Courier New",
                  size: 16
                }),
                new TextRun({
                  children: [PageNumber.CURRENT],
                  font: "Courier New",
                  size: 16
                }),
                new TextRun({
                    text: " of ",
                    font: "Courier New",
                    size: 16
                  }),
               
                new TextRun({
                  children: [PageNumber.TOTAL_PAGES],
                  font: "Courier New",
                  size: 16
                })
              ],
              alignment: AlignmentType.CENTER,
              spacing: {
                before: 200
              }
            })
          ]
        })
      },
      headers: lightWatermarkBase64 ? {
        default: new Header({
          children: [
            new Paragraph({
              children: [
                new ImageRun({
                  data: lightWatermarkBase64,
                  transformation: {
                    width: 500,
                    height: 500
                  },
                  floating: {
                    horizontalPosition: {
                      relative: HorizontalPositionRelativeFrom.PAGE,
                      align: HorizontalPositionAlign.CENTER
                    },
                    verticalPosition: {
                      relative: VerticalPositionRelativeFrom.PAGE,
                      align: VerticalPositionAlign.CENTER
                    },
                    wrap: {
                      type: TextWrappingType.BEHIND_TEXT
                    },
                    allowOverlap: true,
                    behindDocument: true
                  }
                })
              ]
            })
          ]
        })
      } : undefined,
      children: documentSections
    }
  ]
});


        
        Packer.toBlob(doc).then(blob => {
          resolve(blob);
        }).catch(error => {
         
          reject(error);
        });
        });

      }).catch(error => {
        
        reject(error);
      });

    } catch (error) {
     
      reject(error);
    }
  });
};



const handleSubmit = async (e) => {
  e.preventDefault();
 
  setIsLoading(true);
  setErrorMessage("");
  setSuccessMessage("");
  setFormSubmitted(true);
 
  try {
    const allFormData = loadAllFormDataFromStorage();
    const busbarFormData = localStorage.getItem('busbarFormData');
   
    const safeFormData = formData && typeof formData === 'object' ? {
      form: formData.form || allFormData.form,
      testData: formData.testData || allFormData.testData
    } : {
      form: allFormData.form || {},
      testData: allFormData.testData || {},
    };
 
    
    if (!validateForm()) {
      setIsLoading(false);
      return;
    }
 
    const convertArrayToDict = (testData) => {
      const convertedData = {};
     
      for (const [testType, testArray] of Object.entries(testData)) {
        if (Array.isArray(testArray)) {
          convertedData[testType] = {};
          testArray.forEach((item, index) => {
            if (typeof item === 'object' && item !== null) {
              for (const [key, value] of Object.entries(item)) {
                if (!convertedData[testType][key]) {
                  convertedData[testType][key] = {};
                }
                convertedData[testType][key][`reading_${index + 1}`] = value;
              }
            } else {
              convertedData[testType][`reading_${index + 1}`] = item;
            }
          });
        } else {
          convertedData[testType] = testData[testType];
        }
      }
     
      return convertedData;
    };
 
    const convertedTestData = convertArrayToDict(safeFormData.testData || {});
   

 
    const wordBlob = await generateWordBlob({
      form: safeFormData.form,
      testData: convertedTestData
    });
   
    const reader = new FileReader();
    reader.readAsDataURL(wordBlob);
   
    reader.onloadend = async () => {
      try {
        const base64data = reader.result;
       
        localStorage.setItem('busbarTestReportWord', base64data);
       
        const currentDate = new Date().toISOString().split('T')[0];
        const formLocation = safeFormData.form.location || "";
       
        const getProjectId = () => {
         
         
          if (project?.project_id) {
            const id = parseInt(project.project_id);
            if (!isNaN(id) && id > 0) {
              
              return id;
            }
          }
          if (project?.id) {
            const id = parseInt(project.id);
            if (!isNaN(id) && id > 0) {
             
              return id;
            }
          }
       
         
          if (projectDetails.projectId) {
            const id = parseInt(projectDetails.projectId);
            if (!isNaN(id) && id > 0) {
              
              return id;
            }
          }
          
         
          try {
            const createReportData = localStorage.getItem('createReportData');
            if (createReportData) {
              const parsedData = JSON.parse(createReportData);
            
             
              if (parsedData.project_id) {
                const id = parseInt(parsedData.project_id);
                if (!isNaN(id) && id > 0) {
                
                  return id;
                }
              }
            }
          } catch (error) {
           
          }
       
         
          if (safeFormData.form.project_id) {
            const id = parseInt(safeFormData.form.project_id);
            if (!isNaN(id) && id > 0) {
             
              return id;
            }
          }
          
         
          throw new Error("Unable to determine project ID. Please ensure project is properly selected.");
        };
       
        const projectId = getProjectId();
        
        const generateBusbarName = async () => {
  try {
    const response = await fetch(`${API_URL}/test_report/get_test_reports?project_id=${projectId}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
      mode: 'cors',
      credentials: 'same-origin',
    });

    if (response.ok) {
      const result = await response.json();
      const reports = result.data || result.reports || result || [];
      
      
      const busbarReports = reports.filter(r => 
        r.sub_project_name === projectDetails.subProjectName &&
        r.category_name === projectDetails.categoryName &&
        (r.subcategory_name?.toLowerCase().includes('bus bar') || 
         r.subcategory_name?.toLowerCase() === 'busbar')
      );
      
     
      
      
      let maxCounter = 0;
      busbarReports.forEach(report => {
      
        const match = report.equipment_name?.match(/^Busbar_(\d+)$/i);
        if (match) {
          const counter = parseInt(match[1]);
       
          if (counter > maxCounter) {
            maxCounter = counter;
          }
        }
      });
      
      const newCounter = maxCounter + 1;
     
      return `Busbar_${newCounter}`;
    }
  } catch (error) {
  
  }
  
 
  return "Busbar_1";
};

        const equipmentName = await generateBusbarName();
       
       
        const apiRequestData = {
          equipment_name: String(equipmentName), 
          test_date: String(safeFormData.form.date || currentDate),
          category_name: String(projectDetails.categoryName || "Category"),
          subcategory_name: String(projectDetails.subcategoryName || "Subcategory"),
          sub_project_name: String(projectDetails.subProjectName || safeFormData.form.project || "Project"),
          project_id: projectId,
          location: String(formLocation || projectDetails.location || ""),
          report_file: {  
            report_word: base64data,
            filename: `Busbar_Test_Report_${Date.now()}.docx`,
            file_type: "application/vnd.openxmlformats-officedocument.wordprocessingml.document"
          },
          test_data: {
            form: safeFormData.form || {},
            testData: convertedTestData
          }
        };
 
       
 
        const response = await fetch(`${API_URL}/test_report/create_test_report`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(apiRequestData),
          mode: 'cors',
          credentials: 'same-origin',
        });
 
        if (!response.ok) {
          let errorData;
          try {
            errorData = await response.json();
          
          } catch (jsonError) {
            
            errorData = { message: response.statusText };
          }
         
          throw new Error(`API error: ${response.status} - ${errorData.message || errorData.detail || response.statusText}`);
        }
 
        const result = await response.json();
      
 
        alert("Data submitted successfully");
       
      } catch (error) {
      
        setErrorMessage(`Error: ${error.message}`);
        alert(`Error saving data: ${error.message}`);
      } finally {
        setIsLoading(false);
      }
    };
 
    reader.onerror = () => {
      setIsLoading(false);
      setErrorMessage("Error reading Word file");
      alert("Error processing Word file");
    };
   
  } catch (error) {
 
   
    if (error.message.includes("Failed to fetch")) {
      setErrorMessage("Cannot connect to server. Please check if the backend is running.");
      alert("Cannot connect to server. Please check if the backend is running.");
    } else if (error.message.includes("generateWordBlob is not defined")) {
      setErrorMessage("Word document generation function is missing. Please check your imports.");
      alert("Word document generation generation function is missing. Please check your imports.");
    } else if (error.message.includes("Unable to determine project ID")) {
      setErrorMessage(error.message);
      alert(error.message);
    } else {
      setErrorMessage(`Error: ${error.message}`);
      alert(`Error saving data: ${error.message}`);
    }
    setIsLoading(false);
  }
};



  const handleDownloadPDF = async () => {
    setIsLoading(true);
    setErrorMessage("");
    
    try {
      const allFormData = loadAllFormDataFromStorage();
      
      const safeFormData = form && typeof form === 'object' ? {
        form: form,
        testData: testData
      } : {
        form: allFormData.form || {},
        testData: allFormData.testData || {}
      };
      
     
      
      const wordBlob = await generateWordBlob(safeFormData.form, safeFormData.testData);
      
      saveAs(wordBlob, `Busbar_Test_Report_${safeFormData.form.reportNo || Date.now()}.docx`);
      
      setTimeout(() => {
        clearAllStorageData();
        resetAllFormStates();
        alert("Word document downloaded successfully");
      }, 500);
      
    } catch (error) {
      
      setErrorMessage(`Error generating Word document: ${error.message}`);
    } finally {
      setIsLoading(false);
    }
  };


  return (
    <div className="BB-1001">
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <h2 className="BB-1002">BUSBAR REPORT</h2>
        
        <span 
          style={{ 
            display: 'flex',
            justifyContent: 'flex-end',
            fontSize: '20px', 
            fontWeight: '600', 
            color: '#333', 
            cursor: 'pointer',
            marginLeft: '10px',
            marginBottom: '50px'
          }}
          onClick={redirectToHome}
        >
          X
        </span>
      </div>
     
      {errorMessage && (
        <div className="error-message" style={{ color: 'red', margin: '10px 0', padding: '8px', backgroundColor: '#ffeeee', borderRadius: '4px' }}>
          {errorMessage}
        </div>
      )}
     
      {successMessage && (
        <div className="success-message" style={{ color: 'green', margin: '10px 0', padding: '8px', backgroundColor: '#eeffee', borderRadius: '4px' }}>
          {successMessage}
        </div>
      )}
     
      <div className="BB-1004">
        <div>
          <label>Description</label>
          <input
            id="description"
            type="text"
            value="BUSBAR INSPECTION / TEST REPORT"
            maxLength={40}
            placeholder="Enter Description"
            onChange={(e) => handleFormChange("description", e.target.value)}
            className={validationErrors.description ? "input-error" : ""}
            readOnly={"description"}
            style={"description" ? { 
                 
                cursor: 'not-allowed'
              } : {}}
          />
          {validationErrors.description && (
            <div className="error-text" style={{ color: 'red', fontSize: '12px' }}>
              {validationErrors.description}
            </div>
          )}
        </div>
        
        <div>
          <label>Date</label>
          <input
            id="date"
            type="date"
            value={form.date || ''}
            onChange={(e) => handleFormChange("date", e.target.value)}
            
          />
        </div>
        
        <div>
          <label>Customer</label>
          <input
            id="customer"
            type="text"
            value={form.customer || ''}
            maxLength={40}
            placeholder="Enter Customer"
            onChange={(e) => handleFormChange("customer", e.target.value)}
            className={validationErrors.customer ? "input-error" : ""}
          />
          {validationErrors.customer && (
            <div className="error-text" style={{ color: 'red', fontSize: '12px' }}>
              {validationErrors.customer}
            </div>
          )}
        </div>
        
        <div>
          <label>Project</label>
          <input
            id="project"
            type="text"
            value={form.project || ''}
            maxLength={40}
            placeholder="Enter Project"
            onChange={(e) => handleFormChange("project", e.target.value)}
            readOnly={"project"}
                  style={"project" ? { 
                 
                cursor: 'not-allowed'
              } : {}}
            
          />
        </div>
        
        <div>
          <label>ReportNo</label>
          <input
            id="reportNo"
            type="text"
            value={form.reportNo || ''}
            maxLength={40}
            placeholder="Enter ReportNo"
            onChange={(e) => handleFormChange("reportNo", e.target.value)}
            required
          />
        </div>
        
        <div>
          <label>Location</label>
          <input
            id="location"
            type="text"
            value={form.location || ''}
            maxLength={40}
            placeholder="Enter Location"
            onChange={(e) => handleFormChange("location", e.target.value)}
            
          />
        </div>
        
        <div>
          <label>Client</label>
          <input
            id="client"
            type="text"
            value={form.client || ''}
            maxLength={40}
            placeholder="Enter Client"
            onChange={(e) => handleFormChange("client", e.target.value)}
            className={validationErrors.client ? "input-error" : ""}
            readOnly={"client"}
                  style={"client" ? { 
                 
                cursor: 'not-allowed'
              } : {}}
          />
          {validationErrors.client && (
            <div className="error-text" style={{ color: 'red', fontSize: '12px' }}>
              {validationErrors.client}
            </div>
          )}
        </div>
      </div>
   
      <div className="BB-1003">
        <h3 className="BB-1015">CONTACT RESISTANCE TEST</h3>
        
        <div className="BB-1017">
          <div className="contact-resistance-grid">
            <div className="grid-header">S.No</div>
            <div className="grid-header">Reference</div>
            <div className="grid-header grid-header-span">Measured Resistance (µΩ)</div>
            
            <div className="grid-subheader"></div>
            <div className="grid-subheader"></div>
            <div className="grid-subheader">JOINT 1</div>
            <div className="grid-subheader">JOINT 2</div>
            <div className="grid-subheader">OVERALL</div>
            
            {contactResistancePhases.map((phase, index) => {
              const contactData = testData.contactResistance[index] || { joint1: "", joint2: "", overall: "" };
              
              return (
                <React.Fragment key={phase}>
                  <div className="grid-cell grid-sno">{index + 1}</div>
                  <div className="grid-cell grid-reference">{phase}</div>
                  <div className="grid-cell">
                    <input 
                      type="text" 
                      className="grid-input"
                      placeholder="Joint 1 Value"
                      value={contactData.joint1 || ""}
                      maxLength={15}
                      onChange={(e) => handleContactResistanceChange(index, "joint1", e.target.value)}
                    />
                  </div>
                  <div className="grid-cell">
                    <input 
                      type="text" 
                      className="grid-input"
                      placeholder="Joint 2 Value"
                      value={contactData.joint2 || ""}
                      maxLength={15}
                      onChange={(e) => handleContactResistanceChange(index, "joint2", e.target.value)}
                    />
                  </div>
                  <div className="grid-cell">
                    <input 
                      type="text" 
                      className="grid-input"
                      placeholder="Overall Value"
                      value={contactData.overall || ""}
                      maxLength={15}
                      onChange={(e) => handleContactResistanceChange(index, "overall", e.target.value)}
                    />
                  </div>
                </React.Fragment>
              );
            })}
          </div>
        </div>
      </div>
      
      <div className="BB-1003">
        <h3 className="BB-1015">INSULATION RESISTANCE TEST</h3>
       
        <div className="BB-1009 BB-1014">
          <TestInputSection
            title="BEFORE HIPOT INSULATION RESISTANCE TEST"
            values={testData.beforeRun1}
            phases={phases}
            onChange={(i, f, v) => handleTestChange('beforeRun1', i, f, v)}
            validateMeasuredValueInput={validateMeasuredValueInput}
          />
          <TestInputSection
            title="AFTER HIPOT INSULATION RESISTANCE TEST "
            values={testData.afterRun1}
            phases={phases}
            onChange={(i, f, v) => handleTestChange('afterRun1', i, f, v)}
            validateMeasuredValueInput={validateMeasuredValueInput}
          />
        </div>

        <div className="BB-1009 BB-1014">
          <TestInputSection
            title="BEFORE HIPOT INSULATION RESISTANCE TEST "
            values={testData.beforeRun2}
            phases={phases1}
            onChange={(i, f, v) => handleTestChange('beforeRun2', i, f, v)}
            validateMeasuredValueInput={validateMeasuredValueInput}
          />
          <TestInputSection
            title="AFTER HIPOT INSULATION RESISTANCE TEST "
            values={testData.afterRun2}
            phases={phases1}
            onChange={(i, f, v) => handleTestChange('afterRun2', i, f, v)}
            validateMeasuredValueInput={validateMeasuredValueInput}
          />
        </div>
      </div>
     
      <div className="BB-1003">
        <h3 className="BB-1015">HIPOT TEST</h3>
        <h4 className="BB-1016">TEST RESULT :</h4><br/>
        
        <div className="BB-1010 BB-1014">
          <p><strong>HIPOT TEST</strong></p>
          <div className="BB-1006">
            <span>Phase <span style={{ color: "red" }}></span></span>
            <span>Applied DC Voltage (KV) <span style={{ color: "red" }}></span></span>
            <span>Measured Leakage Current (mA) <span style={{ color: "red" }}></span></span>
          </div>
           
          {hipotPhases.map((phase, i) => {
            const hipotItem = testData.hipotRun[i] || { voltage: "", leakage: "" };
            
            return (
              <div className="BB-1007" key={phase}>
                <span className="BB-1013">{phase}</span>
                <input
                  type="text"
                  placeholder="Enter DC Applied Voltage"
                  value={hipotItem.voltage || ""}
                  maxLength={20}
                  onChange={(e) => handleTestChange('hipotRun', i, "voltage", e.target.value)}
                />
                <input
                  type="text"
                  placeholder="Enter Measured Leakage Current"
                  value={hipotItem.leakage || ""}
                  maxLength={10}
                  onChange={(e) => handleTestChange('hipotRun', i, "leakage", e.target.value)}
                />
              </div>
            );
          })}
        </div>
      </div>
     
      <div className="BB-1008">
        <button
          className="cancel-button"
          onClick={goBack}
          disabled={isLoading}
        >
          Back
        </button>
        <button 
          className="btn-next" 
          onClick={handleSubmit}
          disabled={isLoading}
        >
          {isLoading ? "Processing..." : "Submit"}
        </button>
        {formSubmitted && (
          <button 
          className="btn-download" 
          onClick={handleDownloadPDF}
          disabled={isLoading}
          style={{ 
            marginLeft: '10px', 
            backgroundColor: '#4CAF50', 
            cursor: isLoading ? 'not-allowed' : 'pointer' 
          }}
        >
          Download Word
        </button>
        )}
      </div>
    </div>
  );
};

const TestInputSection = ({ title, values, phases, onChange, validateMeasuredValueInput }) => {
  const safeValues = Array.isArray(values) && values.length === phases.length
    ? values
    : phases.map(() => ({ voltage: "", measuredValue: "", measuredUnit: "" }));
    
  return (
    <div className="BB-1010">
      <h4>{title}</h4>
      <div className="BB-1006">
        <span>Phase <span style={{ color: "red" }}></span></span>
        <span>Applied Voltage <span style={{ color: "red" }}></span></span>
        <span>Measured Value <span style={{ color: "red" }}></span></span>
      </div>
     
      {phases.map((phase, i) => {
        const value = safeValues[i] || { voltage: "", measuredValue: "", measuredUnit: "" };
        
        return (
          <div className="BB-1007" key={phase}>
            <span className="BB-1013">{phase}</span>
            <select
              value={value.voltage || ""}
              onChange={(e) => onChange(i, "voltage", e.target.value)}
            >
              <option value="">Select Voltage</option>
              {voltageOptions.map((v) => (
                <option key={v} value={v}>{v}</option>
              ))}
            </select>
           
            <div className="BB-1011">
              <input
                type="text"
                placeholder="Value"
                value={value.measuredValue || ""}
                onChange={(e) => onChange(i, "measuredValue", e.target.value)}
              />
              <select
                value={value.measuredUnit || ""}
                onChange={(e) => onChange(i, "measuredUnit", e.target.value)}
              >
                <option value="">Units</option>
                {unitOptions.map((u) => (
                  <option key={u} value={u}>{u}</option>
                ))}
              </select>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default BusbarTestReport;










